import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            用户热评
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            百万用户的选择，听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 border border-background-200/70 rounded-xl p-4 md:p-5"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>

              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.content}</p>

              <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line" />
                <span>{item.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}